import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './envelope';

/**
 * Shared TanStack Query settings.
 *
 * The choices here suit a content-authoring tool rather than a dashboard:
 * nothing refetches behind the user's back while they are part-way through a
 * form, and failed requests are not retried when retrying cannot possibly help.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as current for 30 seconds before considering a refetch.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      // Refetching when the window regains focus would discard nothing, but it
      // does cause forms to flicker and lists to reorder under the cursor.
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // 4xx means the request itself was wrong; sending it again gives the
        // same answer. 401 has already been dealt with by the token refresh a
        // layer below, so Query must not second-guess it.
        if (error instanceof ApiError && error.isClientError) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // A mutation may already have taken effect before the reply was lost, so
      // an automatic retry risks doing the same thing twice.
      retry: false,
    },
  },
});
